import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

// Restructure messages to use 'common' namespace
const resources: Record<string, { common: Record<string, string> }> = {};
Object.keys(messages).forEach((lang) => {
  resources[lang] = { common: messages[lang].translation };
});

// Supported languages that have actual translation files
export const supportedLanguages = Object.keys(resources);

// Shared helper: maps a region's lang code to a supported i18n language
export function getEffectiveLang(lang: string): string {
  if (supportedLanguages.includes(lang)) return lang;
  const fallbackMap: Record<string, string> = {
    pt: 'es',
    fr: 'en',
    de: 'en',
    it: 'en',
    zh: 'en',
    ja: 'en',
  };
  return fallbackMap[lang] || 'en';
}

i18n
  .use(initReactI18next)
  .init({
    lng: 'es',
    fallbackLng: 'es',
    ns: ['common'],
    defaultNS: 'common',
    debug: false,
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;